/* eslint-disable max-len */
/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const esgPrefill = async (year: string = ''): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;

  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.ESG.preFill.brsrDataPrefill}/${companyID}/${year}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return response.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default esgPrefill;
